(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8551,7620],{

/***/ 44343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "capitalize": function() { return /* reexport */ capitalize/* default */.Z; },
  "createChainedFunction": function() { return /* reexport */ createChainedFunction/* default */.Z; },
  "createSvgIcon": function() { return /* reexport */ createSvgIcon/* default */.Z; },
  "debounce": function() { return /* reexport */ debounce/* default */.Z; },
  "deprecatedPropType": function() { return /* reexport */ deprecatedPropType; },
  "isMuiElement": function() { return /* reexport */ isMuiElement/* default */.Z; },
  "ownerDocument": function() { return /* reexport */ ownerDocument/* default */.Z; },
  "ownerWindow": function() { return /* reexport */ ownerWindow/* default */.Z; },
  "requirePropFactory": function() { return /* reexport */ requirePropFactory; },
  "setRef": function() { return /* reexport */ setRef/* default */.Z; },
  "unstable_useId": function() { return /* reexport */ unstable_useId/* default */.Z; },
  "unsupportedProp": function() { return /* reexport */ unsupportedProp; },
  "useControlled": function() { return /* reexport */ useControlled/* default */.Z; },
  "useEventCallback": function() { return /* reexport */ useEventCallback/* default */.Z; },
  "useForkRef": function() { return /* reexport */ useForkRef/* default */.Z; },
  "useIsFocusVisible": function() { return /* reexport */ useIsFocusVisible/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(42959);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js + 1 modules
var createSvgIcon = __webpack_require__(594);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/debounce.js
var debounce = __webpack_require__(79437);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/deprecatedPropType.js
function deprecatedPropType(validator, reason) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function (props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }

    return null;
  };
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/isMuiElement.js
var isMuiElement = __webpack_require__(83711);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(30626);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerWindow.js
var ownerWindow = __webpack_require__(80713);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/requirePropFactory.js
function requirePropFactory(componentNameInError) {
  if (true) {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/setRef.js
var setRef = __webpack_require__(34236);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/unsupportedProp.js
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useControlled.js
var useControlled = __webpack_require__(22775);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(55192);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(17294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/unstable_useId.js
var unstable_useId = __webpack_require__(95001);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(24896);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/index.js













 // eslint-disable-next-line camelcase




/***/ }),

/***/ 80366:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

exports.Z = _default;

/***/ }),

/***/ 55761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(594);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), 'InfoOutlined'));

/***/ }),

/***/ 2108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function get() {
    return _utils.createSvgIcon;
  }
}));

var _utils = __webpack_require__(44343);

/***/ }),

/***/ 88551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ reusable_ContentWithForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(19393);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./common/BreadCrumbs.tsx + 2 modules
var BreadCrumbs = __webpack_require__(15738);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./common/bit/SingleButtonSelection.tsx
var SingleButtonSelection = __webpack_require__(74962);
// EXTERNAL MODULE: ./common/bit/form/FormikForm.tsx
var FormikForm = __webpack_require__(95055);
// EXTERNAL MODULE: ./common/bit/form/FormikInput.tsx
var FormikInput = __webpack_require__(11852);
// EXTERNAL MODULE: ./common/bit/form/FormikSchema.ts
var FormikSchema = __webpack_require__(46363);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./reusable/wrappers/BodyText.tsx
var BodyText = __webpack_require__(97294);
// EXTERNAL MODULE: ./reusable/wrappers/CenterText.tsx
var CenterText = __webpack_require__(86040);
// EXTERNAL MODULE: ./reusable/wrappers/ImageContainer.tsx
var ImageContainer = __webpack_require__(63358);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./typings/contentPage.ts
var contentPage = __webpack_require__(96860);
;// CONCATENATED MODULE: ./reusable/wrappers/RecallItem.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: ",
        ";\n  grid-gap: 35px;\n  ",
        " {\n    grid-template-columns: 1fr;\n    grid-gap: 20px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: 35px;\n  ",
        " {\n    grid-template-columns: 1fr;\n    grid-gap: 20px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: flex;\n    grid-gap: 13px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 20px;\n  line-height: 160%;\n  /* identical to box height, or 32px */\n\n  letter-spacing: 0.03em;\n\n  /* primary/black */\n\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n\n  font-family: MazdaType, OENaPro, sans-serif;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 150%;\n  /* identical to box height, or 27px */\n\n  /* primary/black */\n\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 140%;\n  margin: 0;\n  letter-spacing: 0.05em;\n\n  color: ",
        ";\n  margin-bottom: 10px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var StyledResponse = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    displayName: "RecallItem__StyledResponse",
    componentId: "sc-264c0f69-0"
})(_templateObject(), function(param) {
    var $columns = param.$columns;
    return "repeat(".concat($columns, ",1fr)");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledItem = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    displayName: "RecallItem__StyledItem",
    componentId: "sc-264c0f69-1"
})(_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledTextContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    displayName: "RecallItem__StyledTextContainer",
    componentId: "sc-264c0f69-2"
})(_templateObject2(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledTopText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "RecallItem__StyledTopText",
    componentId: "sc-264c0f69-3"
})(_templateObject3(), function(p) {
    return p.theme.colors.black;
});
var StyledSubText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "RecallItem__StyledSubText",
    componentId: "sc-264c0f69-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.black;
});
var StyledHeader = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "RecallItem__StyledHeader",
    componentId: "sc-264c0f69-5"
})(_templateObject5(), function(p) {
    return p.theme.colors.black;
});
var recallFields = {
    licenseNumber: "מספר רכב",
    chassisNumber: "מספר שילדה",
    id: "מספר קריאה",
    shortName: "שם קצר"
};
var warrantyFields = {
    licenseNumber: "מספר רכב",
    chassisNumber: "מספר שילדה",
    id: "מספר קריאה",
    phenomenonDesc: "שם קצר"
};
var colorFields = {
    licenseNumber: "מספר רכב",
    colorCode: "קוד צבע",
    colorName: "תיאור צבע"
};
var RecallItem = function(param) {
    var item = param.item, type = param.type, length = param.length;
    var fieldsToMap = type === contentPage/* ContentItemType.COLOR */.o.COLOR ? colorFields : type === contentPage/* ContentItemType.WARRANTYEXTENSION */.o.WARRANTYEXTENSION ? warrantyFields : recallFields;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
                children: [
                    " קריאה מספר ",
                    item.numberCol
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItem, {
                $hasBorder: type !== contentPage/* ContentItemType.COLOR */.o.COLOR,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledResponse, {
                        $columns: type === contentPage/* ContentItemType.COLOR */.o.COLOR ? 3 : 2,
                        children: Object.keys(fieldsToMap).map(function(it, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTextContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopText, {
                                        children: [
                                            fieldsToMap[it],
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubText, {
                                        children: item[it]
                                    })
                                ]
                            }, index.toString());
                        })
                    }),
                    type !== contentPage/* ContentItemType.COLOR */.o.COLOR ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: "מהות הקריאה"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: item.description
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var wrappers_RecallItem = (RecallItem);

// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Table/Table.js
var Table = __webpack_require__(82302);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableBody/TableBody.js
var TableBody = __webpack_require__(99613);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableCell/TableCell.js
var TableCell = __webpack_require__(88222);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableContainer/TableContainer.js
var TableContainer = __webpack_require__(56847);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableHead/TableHead.js
var TableHead = __webpack_require__(83750);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableRow/TableRow.js
var TableRow = __webpack_require__(57394);
;// CONCATENATED MODULE: ./reusable/TableInContent.tsx

function TableInContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  text-align: center;\n  margin: 0 236.5px;\n\n  ",
        " {\n    flex-direction: column;\n    grid-gap: 20px;\n    box-sizing: border-box;\n    margin: 0;\n    grid-template-columns: 1fr;\n    border-bottom: ",
        ";\n  }\n\n  td,\n  th {\n    border: 1px solid ",
        ";\n  }\n  th {\n    background-color: ",
        ";\n  }\n  td {\n    background-color: transparent;\n  }\n"
    ]);
    TableInContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TableInContent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 140%;\n  color: ",
        ";\n"
    ]);
    TableInContent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TableInContent_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "OENAPRO";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 140%;\n  /* or 22px */\n  color: ',
        ";\n"
    ]);
    TableInContent_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TableInContent_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 140%;\n  letter-spacing: 0.05em;\n  color: ",
        ";\n  margin: 0px;\n  padding: 40px 0;\n  ",
        " {\n    text-align: right;\n  }\n"
    ]);
    TableInContent_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TableInContent_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 140%;\n  color: ",
        ";\n  text-align: center;\n  margin: 0;\n  margin-top: 40px;\n  ",
        " {\n    text-align: right;\n  }\n"
    ]);
    TableInContent_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








var StyledItemContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TableInContent__StyledItemContainer",
    componentId: "sc-dba2b2c6-0"
})(TableInContent_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(param) {
    var $hasBorder = param.$hasBorder;
    return $hasBorder ? "1px solid #e7e7e7" : "none";
}, function(p) {
    return p.theme.colors.darkGrey;
}, function(p) {
    return p.theme.colors.white;
});
var TableInContent_StyledHeader = (0,styled_components_browser_esm/* default */.ZP)(TableCell/* default */.Z).withConfig({
    displayName: "TableInContent__StyledHeader",
    componentId: "sc-dba2b2c6-1"
})(TableInContent_templateObject1(), function(p) {
    return p.theme.colors.black;
});
var StyledTD = (0,styled_components_browser_esm/* default */.ZP)(TableCell/* default */.Z).withConfig({
    displayName: "TableInContent__StyledTD",
    componentId: "sc-dba2b2c6-2"
})(TableInContent_templateObject2(), function(p) {
    return p.theme.colors.black;
});
var StyledTableHeader = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "TableInContent__StyledTableHeader",
    componentId: "sc-dba2b2c6-3"
})(TableInContent_templateObject3(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledTableFooter = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "TableInContent__StyledTableFooter",
    componentId: "sc-dba2b2c6-4"
})(TableInContent_templateObject4(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var TableInContent = function(param) {
    var data = param.data;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItemContainer, {
        $hasBorder: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHeader, {
                children: "פירוט הארכות האחריות הפעילות"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableContainer/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableInContent_StyledHeader, {
                                            align: "center",
                                            children: "רכיב"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableInContent_StyledHeader, {
                                            align: "center",
                                            children: "תיאור תופעה"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableInContent_StyledHeader, {
                                            align: "center",
                                            children: "משך הארכת אחריות"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                                children: data.filter(function(_, ind) {
                                    return ind !== data.length - 1;
                                }).map(function(row, ind) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTD, {
                                                align: "center",
                                                children: row.component
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTD, {
                                                align: "center",
                                                children: row.phenomenonDesc
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTD, {
                                                align: "center",
                                                children: row.extensionDuration
                                            })
                                        ]
                                    }, ind.toString());
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableFooter, {
                        children: (ref = data[data.length - 1]) === null || ref === void 0 ? void 0 : ref.component
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var reusable_TableInContent = (TableInContent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(22038);
;// CONCATENATED MODULE: ./reusable/icons/SearchIcon.tsx






var SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? colors/* default.black */.Z.black : _color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    var w = 60;
    var h = 60;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30 52.5C42.4264 52.5 52.5 42.4264 52.5 30C52.5 17.5736 42.4264 7.5 30 7.5C17.5736 7.5 7.5 17.5736 7.5 30C7.5 42.4264 17.5736 52.5 30 52.5Z",
                stroke: color,
                strokeWidth: "2",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.2461 25.1875H33.2461",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.9461 32.9749L37.4836 20.5624C36.9196 20.0044 36.1582 19.6914 35.3648 19.6914C34.5715 19.6914 33.8101 20.0044 33.2461 20.5624V34.6874",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.2469 34.6874V20.5624C26.6829 20.0044 25.9215 19.6914 25.1281 19.6914C24.3347 19.6914 23.5734 20.0044 23.0094 20.5624L17.5469 32.9749",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.2461 39.6875C25.0075 39.6875 27.2461 37.4489 27.2461 34.6875C27.2461 31.9261 25.0075 29.6875 22.2461 29.6875C19.4847 29.6875 17.2461 31.9261 17.2461 34.6875C17.2461 37.4489 19.4847 39.6875 22.2461 39.6875Z",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.2461 39.6875C41.0075 39.6875 43.2461 37.4489 43.2461 34.6875C43.2461 31.9261 41.0075 29.6875 38.2461 29.6875C35.4847 29.6875 33.2461 31.9261 33.2461 34.6875C33.2461 37.4489 35.4847 39.6875 38.2461 39.6875Z",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var SearchIcon = (SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/WarningIcon.tsx






var WarningIcon_SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? colors/* default.black */.Z.black : _color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    var w = 40;
    var h = 40;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 35c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15Z",
                stroke: color,
                strokeWidth: 2,
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 12.5v8.75",
                stroke: color,
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 28.75A1.875 1.875 0 1 0 20 25a1.875 1.875 0 0 0 0 3.75Z",
                fill: color
            })
        ]
    }));
};
/* harmony default export */ var WarningIcon = (WarningIcon_SvgComponent);

// EXTERNAL MODULE: ./reusable/popups/PopUp.tsx
var PopUp = __webpack_require__(24184);
;// CONCATENATED MODULE: ./reusable/ContentWithForm.tsx




function ContentWithForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  display: flex;\n  align-items: center;\n  background: ",
        ";\n  padding-bottom: 80px;\n  input {\n    padding-left: 0px;\n    padding-right: 10px;\n    background-color: white;\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n  }\n  .MuiTextField-root {\n    margin-top: 20px;\n    width: 320px;\n    ",
        " {\n      width: 100%;\n    }\n  }\n"
    ]);
    ContentWithForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContentWithForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 40px;\n  width: 1160px;\n  ",
        " {\n    padding-right: 20px;\n    padding-left: 20px;\n    width: 100%;\n  }\n"
    ]);
    ContentWithForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ContentWithForm_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  width: ",
        ";\n  font-size: 18px;\n  font-weight: 300;\n  margin-top: ",
        ";\n  text-align: center;\n  ",
        " {\n    text-align: right;\n    width: 100%;\n  }\n"
    ]);
    ContentWithForm_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ContentWithForm_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  :focus {\n    outline: none;\n  }\n"
    ]);
    ContentWithForm_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ContentWithForm_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 161px;\n  height: 46px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  transition: 500ms all ease;\n  background-color: ",
        ";\n  color: ",
        ';\n  font-family: "OENaPro";\n  ',
        " {\n    width: 100%;\n  }\n"
    ]);
    ContentWithForm_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ContentWithForm_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 40px;\n  border-radius: 3px;\n  border: 2px solid #4c607e;\n  overflow: hidden;\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    ContentWithForm_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: ",
        ";\n  width: 100%;\n  height: 45px;\n  transition: 200ms all ease;\n  border: none;\n  :hover {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  max-width: 1400px;\n  ",
        " {\n    padding-left: 20px;\n    padding-right: 20px;\n    align-items: start;\n    width: 100%;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 20px;\n  justify-content: center;\n  ",
        " {\n    justify-content: flex-start;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 300;\n  margin-top: 20px;\n  text-align: center;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin: 45px 10px 0 10px;\n  grid-gap: 40px;\n  width: ",
        ";\n  align-items: ",
        ";\n  ",
        " {\n    grid-gap: 20px;\n    margin: 27px 4px 0 4px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 0.5px solid ",
        ";\n  display: flex;\n\n  align-items: center;\n  justify-content: center;\n  padding-top: 32px;\n  grid-gap: 8px;\n\n  ",
        " {\n    padding-top: 20px;\n    align-items: flex-start;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 150%;\n  color: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 40px;\n  height: 40px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 20px;\n  line-height: 160%;\n  letter-spacing: 0.03em;\n  color: ",
        ";\n  text-align: right;\n  margin: 0;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "OENAPRO";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 150%;\n  text-align: right;\n  list-style-type: none;\n  color: ',
        ';\n  margin-top: 20px;\n  ::before {\n    content: "";\n    display: inline-block;\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background: ',
        ";\n    margin-left: 10px;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}





















var StyledPageDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContentWithForm__StyledPageDiv",
    componentId: "sc-86c1b067-0"
})(ContentWithForm_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledTextWrapp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContentWithForm__StyledTextWrapp",
    componentId: "sc-86c1b067-1"
})(ContentWithForm_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledBody = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "ContentWithForm__StyledBody",
    componentId: "sc-86c1b067-2"
})(ContentWithForm_templateObject2(), function(p) {
    return p.$width ? "".concat(p.$width, "px") : "985px";
}, function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "10px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    displayName: "ContentWithForm__StyledLabel",
    componentId: "sc-86c1b067-3"
})(ContentWithForm_templateObject3());
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    displayName: "ContentWithForm__StyledButton",
    componentId: "sc-86c1b067-4"
})(ContentWithForm_templateObject4(), function(p) {
    return p.$isSelected ? "#4C607E" : "#FFF";
}, function(p) {
    return p.$isSelected ? "#FFFFFF" : "#616161";
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledButtonDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContentWithForm__StyledButtonDiv",
    componentId: "sc-86c1b067-5"
})(ContentWithForm_templateObject5(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledBtn = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "ContentWithForm__StyledBtn",
    componentId: "sc-86c1b067-6"
})(_templateObject6(), function(p) {
    return p.theme.colors.headerColor;
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.colors.darkBlack;
});
var StyledBottomWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContentWithForm__StyledBottomWrap",
    componentId: "sc-86c1b067-7"
})(_templateObject7(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledBtnWrapp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContentWithForm__StyledBtnWrapp",
    componentId: "sc-86c1b067-8"
})(_templateObject8(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledNotFound = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContentWithForm__StyledNotFound",
    componentId: "sc-86c1b067-9"
})(_templateObject9());
var StyledBottom = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "ContentWithForm__StyledBottom",
    componentId: "sc-86c1b067-10"
})(_templateObject10());
var StyledResponseContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    displayName: "ContentWithForm__StyledResponseContainer",
    componentId: "sc-86c1b067-11"
})(_templateObject11(), function(param) {
    var $isFullWidth = param.$isFullWidth;
    return $isFullWidth ? "100%" : "auto";
}, function(param) {
    var $isFullWidth = param.$isFullWidth;
    return $isFullWidth ? "center" : "right";
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledWarning = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    displayName: "ContentWithForm__StyledWarning",
    componentId: "sc-86c1b067-12"
})(_templateObject12(), function(p) {
    return p.theme.colors.darkGrey;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledWarningText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "ContentWithForm__StyledWarningText",
    componentId: "sc-86c1b067-13"
})(_templateObject13(), function(p) {
    return p.theme.colors.black;
});
var StyledIconWrap = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    displayName: "ContentWithForm__StyledIconWrap",
    componentId: "sc-86c1b067-14"
})(_templateObject14());
var StyledTableBottomHeader = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "ContentWithForm__StyledTableBottomHeader",
    componentId: "sc-86c1b067-15"
})(_templateObject15(), function(p) {
    return p.theme.colors.black;
});
var StyledListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "ContentWithForm__StyledListItem",
    componentId: "sc-86c1b067-16"
})(_templateObject16(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.black;
});
var ContentWithForm = function(param) {
    var title = param.title, background = param.background, subtitle = param.subtitle, buttons = param.buttons, inputLabel = param.inputLabel, inputType = param.inputType, submitText = param.submitText, bottomTitle = param.bottomTitle, phoneNumber = param.phoneNumber, bottomSubTitle = param.bottomSubTitle, headerText = param.headerText, getData = param.getData, type = param.type, tableData = param.tableData, page = param.page, breadCrumbName = param.breadCrumbName;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var ref = (0,react.useState)(null), recallResponse = ref[0], setRecallResponse = ref[1];
    var ref1 = (0,react.useState)(buttons[0].value), selectedButton = ref1[0], setSelectedButton = ref1[1];
    var ref2 = (0,react.useState)(null), inputValue = ref2[0], setInputValue = ref2[1];
    var ref3 = (0,react.useState)(false), notFound = ref3[0], setNotFound = ref3[1];
    var handleButtonClick = function(buttonValue) {
        setSelectedButton(buttonValue);
    };
    var ref4 = (0,react.useState)(false), modalOpen = ref4[0], setModalOpen = ref4[1];
    var renderButtons = function(radioId, isSelected, item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLabel, {
            htmlFor: radioId,
            $activeButton: isSelected,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                $isSelected: isSelected,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: item.name
                })
            })
        });
    };
    var handleModalClose = function() {
        setModalOpen(false);
        setRecallResponse(null);
    };
    var initialValuesFromButtons = buttons.reduce(function(obj, item) {
        return Object.assign(obj, (0,_define_property/* default */.Z)({}, item.value, ""));
    }, {});
    var schemaCard = (0,react.useMemo)(function() {
        return es/* object */.Ry().shape((0,_define_property/* default */.Z)({}, selectedButton, selectedButton === "licenseNumber" ? FormikSchema/* schemaCommon.licenseNumber */.Cr.licenseNumber : FormikSchema/* schemaCommon.chassis */.Cr.chassis));
    }, [
        selectedButton
    ]);
    var renderForm = function(param) {
        var setFieldValue = param.setFieldValue, values = param.values, setFieldTouched = param.setFieldTouched;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInput/* default */.Z, {
                    value: values[selectedButton],
                    name: selectedButton,
                    id: selectedButton,
                    autoComplete: "off",
                    onChange: function(e) {
                        setFieldTouched("licenseNumber");
                        setFieldValue(selectedButton, e.target.value);
                    },
                    numeric: selectedButton === "licenseNumber" ? true : false,
                    label: page ? "מספר ".concat(selectedButton === "licenseNumber" ? "רישוי" : "שילדה", " (הקלדת מס׳ משמאל לימין)") : inputLabel,
                    type: selectedButton === "licenseNumber" ? "number" : inputType
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBtnWrapp, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBtn, {
                        type: "submit",
                        children: submitText
                    })
                })
            ]
        });
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getData(values[selectedButton], selectedButton)
                        ];
                    case 1:
                        data = _state.sent().data;
                        setInputValue(values[selectedButton]);
                        setRecallResponse(data);
                        setNotFound((data === null || data === void 0 ? void 0 : data.data.length) ? false : true);
                        setModalOpen(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var getEmptyResponseByTypeAndSelectedButton = (0,react.useCallback)(function() {
        var emptyText = "";
        var selectedButtonText = selectedButton === "licenseNumber" ? "רכב מספר" : "שילדה מספר";
        switch(type){
            case contentPage/* ContentItemType.COLOR */.o.COLOR:
                emptyText = "לא נמצא קוד צבע עבור ".concat(selectedButtonText);
                break;
            case contentPage/* ContentItemType.SERVICE */.o.SERVICE:
                emptyText = "לא נמצאה הוראת שירות עבור ".concat(selectedButtonText);
                break;
            case contentPage/* ContentItemType.WARRANTYEXTENSION */.o.WARRANTYEXTENSION:
                emptyText = "לא נמצאה הארכת אחריות עבור ".concat(selectedButtonText);
                break;
            default:
                emptyText = "לא נמצאה הוראת שירות עבור ".concat(selectedButtonText);
                break;
        }
        return emptyText;
    }, [
        type,
        selectedButton
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledPageWrapper */.S0, {
        $padding: "0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUp/* default */.Z, {
                open: modalOpen,
                setOpen: handleModalClose,
                width: notFound && 320,
                children: (recallResponse === null || recallResponse === void 0 ? void 0 : recallResponse.data.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledResponseContainer, {
                    $isFullWidth: type === contentPage/* ContentItemType.COLOR */.o.COLOR,
                    children: [
                        recallResponse.data.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(wrappers_RecallItem, {
                                item: item,
                                type: type,
                                length: recallResponse.data.length
                            }, index.toString());
                        }),
                        type !== contentPage/* ContentItemType.COLOR */.o.COLOR ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWarning, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconWrap, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningIcon, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWarningText, {
                                    children: [
                                        "שים לב, יש לתאם מראש טלפונית את מועד הגעתך למרכז השירות, לרשימת מרכזי שירות",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                                            $color: "#4C607E",
                                            href: "/services-centers",
                                            children: "לחצו כאן"
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        }) : null
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNotFound, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CenterText/* StyledHeaderH1 */.O, {
                            $margin: 7.5,
                            $align: "center",
                            children: getEmptyResponseByTypeAndSelectedButton()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CenterText/* StyledHeaderH1 */.O, {
                            $margin: 20,
                            $break: "break-all",
                            children: inputValue
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBottom, {
                            $margin: 20,
                            children: "מאחלים לכם נסיעה טובה ועומדים לרשותכם בכל עת"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageDiv, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer/* default */.Z, {
                        src: isDesktop ? background[1] : background[0]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                        name: breadCrumbName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTextWrapp, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CenterText/* default */.Z, {
                                headerText: headerText,
                                title: title,
                                withBorder: !!subtitle,
                                page: page
                            }),
                            tableData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(reusable_TableInContent, {
                                data: tableData
                            }) : null,
                            subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBody, {
                                $margin: 40,
                                $width: 410,
                                children: subtitle
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBottomWrap, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonDiv, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleButtonSelection/* default */.Z, {
                                    id: "routesSelect",
                                    items: buttons,
                                    onSelect: handleButtonClick,
                                    gap: 15,
                                    itemsPerRow: "auto",
                                    customButton: renderButtons
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikForm/* default */.Z, {
                                initialValues: initialValuesFromButtons,
                                validationSchema: schemaCard,
                                onSubmit: handleSubmit,
                                render: renderForm
                            }),
                            tableData ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledH3 */.eX, {
                                        children: bottomTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                                        href: "tel: ".concat(phoneNumber),
                                        $margin: 10,
                                        $color: "#4C607E",
                                        style: {
                                            unicodeBidi: "plaintext"
                                        },
                                        children: phoneNumber
                                    }),
                                    bottomSubTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBody, {
                                        $margin: 40,
                                        $width: 780,
                                        children: bottomSubTitle
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    tableData ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTextWrapp, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableBottomHeader, {
                                children: "לתשומת ליבך"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledListItem, {
                                children: "האפשרות להארכת האחריות על ידי היצרן מוצגת לידיעה כללית בלבד. תחולתה של הארכת האחריות ביחד לרכב מסוים תיבחן ותיקבע באופן פרטני בהתאם להגדרות היצרן בהיבט זמן/מד אוץ, אופי התקלה וסייגים נוספים כפי שקבע ביצרן במועד הבאתו של הרכב אל מרכז שירות מורשה."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledListItem, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                                    href: "/services-centers",
                                    $color: " #4C607E",
                                    children: "לאיתור מרכז שירות מורשה"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledListItem, {
                                children: [
                                    "לכל שאלה ניתן לפנות למוקד שירות הלקוחות בטלפון",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                                        $color: " #4C607E",
                                        href: "tel:*2880",
                                        style: {
                                            unicodeBidi: "plaintext"
                                        },
                                        children: "*2880"
                                    }),
                                    " ",
                                    "או בכתובת הדואר האלקטרוני",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                                        $color: " #4C607E",
                                        href: "mailto:service1@delekmotors.co.il",
                                        children: "service1@delekmotors.co.il"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledListItem, {
                                children: "משך האחריות נמדד ממועד עליית הרכב לכביש."
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var reusable_ContentWithForm = (ContentWithForm);


/***/ }),

/***/ 24184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PopUp; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52663);
/* harmony import */ var _material_ui_core_DialogContent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29525);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55761);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .MuiDialog-paperWidthSm {\n    border-radius: 8px;\n    overflow: hidden;\n    margin: 0 20px;\n  }\n  .MuiBackdrop-root {\n    background: rgba(16, 16, 16, 0.5);\n    webkit-backdropfilter: blur(0px);\n    backdrop-filter: blur(0px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 30px;\n  right: 30px;\n  padding: 0px;\n  color: ",
        ";\n  &:hover {\n    background-color: transparent;\n  }\n  ",
        " {\n    top: 5.25px;\n    right: 15.25px;\n    z-index: 10;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  overflow-y: scroll;\n  padding: 30px !important;\n\n  ",
        " {\n    padding: 20px !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: OENaPro;\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  color: ",
        ";\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 22.4px;\n  ",
        " {\n    font-family: OENaPro;\n    font-weight: 400;\n    font-size: 24px;\n    line-height: 33.6px;\n    letter-spacing: 0.8px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 130%;\n  margin: 0 10px;\n\n  text-align: center;\n\n  color: #616161;\n  margin-top: 15.5px;\n\n  ",
        " {\n    margin: 0 30px;\n    margin-top: 15.5px;\n\n    font-style: normal;\n    font-weight: 300;\n    font-size: 12px;\n    line-height: 130%;\n\n    text-align: center;\n\n    color: #616161;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  color: #999999;\n  background-color: transparent;\n  border: none;\n  font-size: 20px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 130%;\n  margin: 0 10px;\n\n  text-align: center;\n\n  color: ",
        ";\n\n  ",
        " {\n    margin: 0 30px;\n\n    font-style: normal;\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 130%;\n\n    text-align: center;\n\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}









var StyledDialog = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    displayName: "PopUp__StyledDialog",
    componentId: "sc-ec9d74b2-0"
})(_templateObject());
var StyledContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_DialogContent__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "PopUp__StyledContent",
    componentId: "sc-ec9d74b2-1"
})(_templateObject1());
var StyledCloseButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    displayName: "PopUp__StyledCloseButton",
    componentId: "sc-ec9d74b2-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledScrollable = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PopUp__StyledScrollable",
    componentId: "sc-ec9d74b2-3"
})(_templateObject3(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PopUp__StyledHeaderContainer",
    componentId: "sc-ec9d74b2-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSubHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PopUp__StyledSubHeaderContainer",
    componentId: "sc-ec9d74b2-5"
})(_templateObject5(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "PopUp__StyledButton",
    componentId: "sc-ec9d74b2-6"
})(_templateObject6());
var StyledDarkSubHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PopUp__StyledDarkSubHeaderContainer",
    componentId: "sc-ec9d74b2-7"
})(_templateObject7(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.colors.black;
});
function PopUp(param) {
    var setOpen = param.setOpen, open = param.open, children = param.children, header = param.header, maxWidth = param.maxWidth, width = param.width, customClose = param.customClose, subHeader = param.subHeader, darkSubHeader = param.darkSubHeader;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isSubHeaderOpen = ref[0], setIsSubHeaderOpen = ref[1];
    var handleClose = function() {
        customClose ? customClose() : setOpen(false);
    };
    var handleSubClick = function() {
        setIsSubHeaderOpen(!isSubHeaderOpen);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledDialog, {
        maxWidth: maxWidth,
        onClose: handleClose,
        "aria-labelledby": "customized-dialog-title",
        open: open,
        style: width ? {
            width: width,
            margin: "auto"
        } : null,
        "aria-modal": "true",
        tabIndex: -1,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledContent, {
            children: [
                header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledHeaderContainer, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .TypographyCenter */ .kc, {
                            variant: "h2",
                            $fontSize: "24px",
                            $fontWeight: "400",
                            children: header
                        }),
                        subHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
                            onClick: handleSubClick,
                            "aria-expanded": isSubHeaderOpen ? true : false,
                            "aria-label": "מידע נוסף",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                fontSize: "inherit",
                                style: {
                                    color: "#616161",
                                    fill: "#616161"
                                }
                            })
                        })
                    ]
                }),
                darkSubHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledDarkSubHeaderContainer, {
                    children: darkSubHeader
                }),
                subHeader && isSubHeaderOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubHeaderContainer, {
                    children: subHeader
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCloseButton, {
                    onClick: handleClose,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledScrollable, {
                    children: children
                })
            ]
        })
    });
}


/***/ }),

/***/ 86040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ StyledHeaderH1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57402);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  ",
        " {\n    text-align: right;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: ",
        ";\n  margin-top: ",
        ";\n  word-break: ",
        ';\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n  color: ',
        ";\n  ",
        " {\n    text-align: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  margin-top: 20px;\n  font-weight: 300;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  margin-top: 20px;\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 27px;\n  color: ',
        ";\n  width: ",
        ";\n  margin: auto;\n  ",
        ";\n  ",
        " {\n    text-align: right;\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 0.5px;\n  background-color: ",
        ";\n  margin-top: 40px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var StyledCenterText = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CenterText__StyledCenterText",
    componentId: "sc-cd579a81-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledHeaderH1 = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "h1"
}).withConfig({
    displayName: "CenterText__StyledHeaderH1",
    componentId: "sc-cd579a81-1"
})(_templateObject1(), function(p) {
    return p.$margin ? "center" : "center";
}, function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "0";
}, function(p) {
    return p.$break && p.$break;
}, function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$align ? p.$align : "right";
});
var StyledHeaderSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "CenterText__StyledHeaderSubtitle",
    componentId: "sc-cd579a81-2"
})(_templateObject2());
var StyledBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "CenterText__StyledBody",
    componentId: "sc-cd579a81-3"
})(_templateObject3(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.$page === "color" ? "500px" : "985px";
}, function(p) {
    return p.$margin && "margin-top: 20px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledLine = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CenterText__StyledLine",
    componentId: "sc-cd579a81-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.darkGrey;
});
var StyledFooterText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "CenterText__StyledFooterText",
    componentId: "sc-cd579a81-5"
})(_templateObject5());
var CenterText = function(param) {
    var title = param.title, subtitle = param.subtitle, headerText = param.headerText, footerText = param.footerText, withBorder = param.withBorder, margin = param.margin, page = param.page;
    var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .useIsDesktop */ .Ce)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledCenterText, {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeaderH1, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeaderSubtitle, {
                children: subtitle
            }),
            headerText.map(function(text) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBody, {
                    $margin: margin,
                    $page: page,
                    children: text
                }, text);
            }),
            footerText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledFooterText, {
                children: footerText
            }) : null,
            isDesktop && withBorder && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLine, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CenterText);


/***/ }),

/***/ 96860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ContentItemType; }
/* harmony export */ });
var ContentItemType;
(function(ContentItemType) {
    ContentItemType[ContentItemType["COLOR"] = 0] = "COLOR";
    ContentItemType[ContentItemType["RECALL"] = 1] = "RECALL";
    ContentItemType[ContentItemType["SERVICE"] = 2] = "SERVICE";
    ContentItemType[ContentItemType["WARRANTYEXTENSION"] = 3] = "WARRANTYEXTENSION";
})(ContentItemType || (ContentItemType = {}));


/***/ }),

/***/ 75263:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(18698)["default"]);
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 18698:
/***/ (function(module) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ })

}]);